<template>
  <div class="checkbox-container">
    <input type="checkbox" :name="name" :id="uuid" @click="onChange" ref="checkBoxElement" />
  </div>
</template>

<script>
  import { genRandomId } from '@shared/helpers/utils';
  export default {
    name: 'Checkbox',
    props: {
      acceptIndeterminate: {
        type: Boolean,
        default: true
      },
      indeterminate: {
        type: Boolean,
        default: false
      },
      checked: {
        type: Boolean,
        default: false
      },
      name: {
        type: String,
        default: ''
      },
      uuid: {
        type: String,
        default: genRandomId()
      }
    },
    watch: {
      indeterminate: {
        immediate: true,
        handler(isImmediate) {
          if (this.acceptIndeterminate && this.checkboxElement) {
            if (isImmediate) {
              this.checkboxElement.readOnly = this.checkboxElement.indeterminate = true;
              this.checkboxElement.checked = false;
            } else {
              this.checkboxElement.readOnly = this.checkboxElement.indeterminate = this.checkboxElement.checked = false;
            }
          }
        }
      },
      checked: {
        immediate: true,
        handler(isChecked) {
          if (this.checkboxElement) {
            if (isChecked) {
              this.checkboxElement.checked = true;
              this.checkboxElement.readOnly = this.checkboxElement.indeterminate = false;
            } else {
              this.checkboxElement.checked = false;
              this.checkboxElement.readOnly = this.checkboxElement.indeterminate = this.indeterminate;
            }
          }
        }
      }
    },
    data() {
      return {
        checkboxElement: null
      };
    },
    mounted() {
      this.checkboxElement = this.$refs.checkBoxElement;
      this.initState();
    },
    methods: {
      onChange(event) {
        event.stopPropagation();
        if (this.checkboxElement.readOnly) {
          this.checkboxElement.checked = this.checkboxElement.readOnly = false;
        } else if (!this.checkboxElement.checked && this.acceptIndeterminate) {
          this.checkboxElement.readOnly = this.checkboxElement.indeterminate = true;
        }
        setTimeout(() => {
          this.$emit('change', {
            indeterminate: this.checkboxElement.indeterminate,
            checked: this.checkboxElement.checked
          });
        });
      },
      initState() {
        if (this.acceptIndeterminate && this.indeterminate && this.checkboxElement) {
          this.checkboxElement.readOnly = this.checkboxElement.indeterminate = true;
          this.checkboxElement.checked = false;
        }
        if (this.checked && this.checkboxElement) {
          this.checkboxElement.checked = true;
          this.checkboxElement.readOnly = this.checkboxElement.indeterminate = false;
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .checkbox-container {
    display: flex;
    width: auto;
    max-width: 80px;
  }
</style>
